import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Sparkles, Heart, Shield, Zap } from 'lucide-react';

export default function AboutSettings() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#050505]">
      {/* Header */}
      <div className="sticky top-12 z-40 bg-[#050505] border-b border-white/5 px-4 py-3">
        <div className="flex items-center gap-3">
          <button 
            onClick={() => navigate('/settings')} 
            className="p-2 -ml-2 text-[#A1A1AA] hover:text-white"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          <h1 className="text-lg font-bold text-white font-['Unbounded']">About Us</h1>
        </div>
      </div>

      <div className="px-4 py-6">
        {/* Logo */}
        <div className="flex flex-col items-center mb-8">
          <div className="w-20 h-20 rounded-2xl bg-[#E11D48] flex items-center justify-center mb-4">
            <Sparkles className="w-10 h-10 text-white" />
          </div>
          <h2 className="text-2xl font-bold text-white font-['Unbounded']">Animus</h2>
          <p className="text-[#71717A] mt-1">Version 1.0.0</p>
        </div>

        {/* Description */}
        <div className="p-4 bg-[#0F1115] rounded-xl border border-white/5 mb-6">
          <p className="text-[#A1A1AA] leading-relaxed">
            Animus is a platform where you can chat with AI-powered characters. 
            From anime heroes to fantasy legends, create your own companions and 
            explore endless conversations powered by advanced AI.
          </p>
        </div>

        {/* Features */}
        <div className="space-y-3">
          <h3 className="text-sm font-medium text-[#71717A] uppercase tracking-wider mb-3">Features</h3>
          
          <div className="flex items-center gap-3 p-3 bg-[#0F1115] rounded-xl border border-white/5">
            <div className="p-2 bg-[#E11D48]/10 rounded-lg">
              <Heart className="w-5 h-5 text-[#E11D48]" />
            </div>
            <div>
              <p className="text-white font-medium">Millions of Characters</p>
              <p className="text-xs text-[#71717A]">Chat with any character you can imagine</p>
            </div>
          </div>

          <div className="flex items-center gap-3 p-3 bg-[#0F1115] rounded-xl border border-white/5">
            <div className="p-2 bg-[#E11D48]/10 rounded-lg">
              <Sparkles className="w-5 h-5 text-[#E11D48]" />
            </div>
            <div>
              <p className="text-white font-medium">Create Your Own</p>
              <p className="text-xs text-[#71717A]">Build and share custom characters</p>
            </div>
          </div>

          <div className="flex items-center gap-3 p-3 bg-[#0F1115] rounded-xl border border-white/5">
            <div className="p-2 bg-[#F59E0B]/10 rounded-lg">
              <Shield className="w-5 h-5 text-[#F59E0B]" />
            </div>
            <div>
              <p className="text-white font-medium">Private & Secure</p>
              <p className="text-xs text-[#71717A]">Your conversations stay private</p>
            </div>
          </div>

          <div className="flex items-center gap-3 p-3 bg-[#0F1115] rounded-xl border border-white/5">
            <div className="p-2 bg-green-500/10 rounded-lg">
              <Zap className="w-5 h-5 text-green-500" />
            </div>
            <div>
              <p className="text-white font-medium">Advanced AI</p>
              <p className="text-xs text-[#71717A]">Powered by GPT-5.2</p>
            </div>
          </div>
        </div>

        {/* Legal Links */}
        <div className="mt-8 space-y-2">
          <a href="#" className="block p-3 text-[#71717A] text-sm hover:text-white transition-colors">
            Terms of Service
          </a>
          <a href="#" className="block p-3 text-[#71717A] text-sm hover:text-white transition-colors">
            Privacy Policy
          </a>
          <a href="#" className="block p-3 text-[#71717A] text-sm hover:text-white transition-colors">
            Contact Support
          </a>
        </div>

        {/* Copyright */}
        <p className="text-center text-[#71717A] text-xs mt-8">
          © 2026 Animus. All rights reserved.
        </p>
      </div>
    </div>
  );
}
